export const LANDING = "/";
export const EMPLOYEE = "/";
export const APPROVE_EXPENSE = "/approveExpense";
export const ADD_EXPENSE = "/addExpense";
export const ADD_CREDIT = "/addCredit";
export const DOWNLOAD = "/download";
export const HELP = "/help";
